import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/template/Header';
import Footer from '../../components/template/Footer';
import BreadCrumb from '../../components/template/BreadCrumb';
import { Link } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import { LittleAngels } from '../../models/littleangel';

function AllLittleAngles() {
  const [littleAngles, setLittleAngles] = useState(LittleAngels);
  return (
    <div>
      <Header active='SUCCESS_STORIES' />
      <BreadCrumb title={'Our Little Angels'} />
      <section className='current ptb-30'>
        <div className='container'>
          <div className='current-project angel-border'>
            <div className='row'>
              <div className='col-md-5'>
                <div className='little-angel-img'>
                  <img src='/assets/images/hamda.png' alt='' />
                </div>
              </div>
              <div className='col-md-7'>
                <div className='little-angel-title'>Hamda</div>
                <div className='little-angel-age'>2 Years</div>
                {/* <div className="little-angel-documents">
                                    <p className="medical-documents">Medical Documents </p>
                                </div> */}
                <div className='little-angel-description'>
                  <div className='little-angel-heading'>
                    <p>
                      <strong>In Loving Memory of Hamda</strong>
                    </p>
                  </div>
                  <div className='little-angel-para'>
                    <p>
                      It is with profound sorrow that we share the news of
                      Hamda's passing. Hamda was a beacon of hope and
                      resilience, inspiring everyone around him with his courage
                      and unwavering spirit. His journey touched the hearts of
                      many, and his legacy will continue to inspire us all.
                    </p>

                    <p>
                      At the National Organisation for Social Empowerment, we
                      were privileged to be a part of Hamda's life. His
                      determination and positivity in the face of adversity were
                      truly remarkable. While he may no longer be with us, his
                      story remains a testament to the strength of the human
                      spirit.
                    </p>

                    <p>
                      We extend our deepest condolences to Hamda's family and
                      loved ones during this difficult time. His memory will
                      forever remain in our hearts, and we are committed to
                      honoring his legacy by continuing our mission to support
                      and empower those in need.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default AllLittleAngles;
